import { render, staticRenderFns } from "./ordered.vue?vue&type=template&id=6d6bb0ab&scoped=true"
import script from "./ordered.vue?vue&type=script&lang=js"
export * from "./ordered.vue?vue&type=script&lang=js"
import style0 from "./ordered.vue?vue&type=style&index=0&id=6d6bb0ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6bb0ab",
  null
  
)

export default component.exports